<template>
  <div>
    <div id="container" style="height: 700px;"></div>
  </div>
</template>

<script>
export default {
  name: "two",
  components: {},
  data() {
    return {
      mapData: [
        { lat: 116.355345, lon: 39.921718 },
        { lat: 116.395817, lon: 39.938135 },
        { lat: 116.445296, lon: 39.92988 },
        { lat: 116.400066, lon: 39.975042 }
      ]
    };
  },
  methods: {},
  mounted() {
    var map = new AMap.Map("container", {
      center: [116.413582, 39.937186],
      zoom: 12
    });

    //为地图注册click事件获取鼠标点击出的经纬度坐标
    map.on("click", function(e) {});

    var mapData = this.mapData;
    for (var i = 0; i < mapData.length; i++) {
      var circle = new AMap.Circle({
        center: [mapData[i].lat, mapData[i].lon],
        radius: 600, //半径
        borderWeight: 3,
        strokeColor: "#FF33FF",
        strokeOpacity: 1,
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        strokeStyle: "dashed",
        strokeDasharray: [10, 10],
        // 线样式还支持 'dashed'
        fillColor: "#1791fc",
        zIndex: 50
      });
      var marker = new AMap.Marker({
        icon: new AMap.Icon({
          size: new AMap.Size(40, 40), //图标大小
          imageSize: new AMap.Size(40, 40)
        }),
        position: [mapData[i].lat, mapData[i].lon],
        map: map
      });

      marker.on("click", markerClick);

      function markerClick(e) {}

      marker.setMap(map);
      circle.setMap(map);
    }

    //步行导航
    var walking = new AMap.Walking({
      map: map
    });
    //根据起终点坐标规划步行路线
    walking.search(
      [116.355345, 39.921718],
      [116.445296, 39.92988],
      [116.400066, 39.975042]
    );
  },
  created: function() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/two.vue